// src/parts/Header.jsx

import React, { useState } from "react";
import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink, useLocation } from "react-router-dom";
import logo from '../assets/images/honex-logo.png';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const isHomePage = location.pathname === '/';

  const navLinks = (
    <>
      {isHomePage ? (
        <>
          <ScrollLink to="home" smooth={true} duration={500} offset={-100} className="cursor-pointer hover:text-hovered">Home</ScrollLink>
          <RouterLink to="/about" className="cursor-pointer hover:text-hovered">About Us</RouterLink>
          <RouterLink to="/services" className="cursor-pointer hover:text-hovered">Services</RouterLink>
          <RouterLink to="/gallery" className="cursor-pointer hover:text-hovered">Gallery</RouterLink>
          <RouterLink to="/contact-us" className="bg-yellow-600 text-white px-4 py-2 rounded-md hover:bg-yellow-700 transition-colors duration-300">Get in Touch</RouterLink>
        </>
      ) : (
        <>
          <RouterLink to="/" className="cursor-pointer hover:text-hovered">Home</RouterLink>
          <RouterLink to="/about" className="cursor-pointer hover:text-hovered">About Us</RouterLink>
          <RouterLink to="/services" className="cursor-pointer hover:text-hovered">Services</RouterLink>
          <RouterLink to="/gallery" className="cursor-pointer hover:text-hovered">Gallery</RouterLink>
          <RouterLink to="/contact-us" className="bg-yellow-600 text-white px-4 py-2 rounded-md hover:bg-yellow-700 transition-colors duration-300">Get in Touch</RouterLink>
        </>
      )}
    </>
  );

  const mobileNavLinks = (
    <>
      {isHomePage ? (
        <>
          <ScrollLink to="home" smooth={true} duration={500} offset={-1000} className="block text-white cursor-pointer" onClick={() => setIsOpen(false)}>Home</ScrollLink>
          <RouterLink to="/about" className="block px-4 py-2 text-white hover:bg-bg cursor-pointer" onClick={() => setIsOpen(false)}>About Us</RouterLink>
          <RouterLink to="/services" className="block px-4 py-2 text-white hover:bg-bg cursor-pointer" onClick={() => setIsOpen(false)}>Services</RouterLink>
         <RouterLink to="/gallery" className="block px-4 py-2 text-white hover:bg-bg cursor-pointer" onClick={() => setIsOpen(false)}>Gallery</RouterLink>
          <RouterLink to="/contact-us" className="block bg-yellow-600 text-white px-4 py-2 rounded-md hover:bg-yellow-700 transition-colors duration-300" onClick={() => setIsOpen(false)}>Get in Touch</RouterLink>
        </>
      ) : (
        <>
          <RouterLink to="/" className="block px-4 py-2 text-white hover:bg-bg cursor-pointer" onClick={() => setIsOpen(false)}>Home</RouterLink>
          <RouterLink to="/about" className="block px-4 py-2 text-white hover:bg-bg cursor-pointer" onClick={() => setIsOpen(false)}>About Us</RouterLink>
          <RouterLink to="/services" className="block px-4 py-2 text-white hover:bg-bg cursor-pointer" onClick={() => setIsOpen(false)}>Services</RouterLink>
          <RouterLink to="/gallery" className="block px-4 py-2 text-white hover:bg-bg cursor-pointer" onClick={() => setIsOpen(false)}>Gallery</RouterLink>
          <RouterLink to="/contact-us" className="block bg-yellow-600 text-white px-4 py-2 rounded-md hover:bg-yellow-700 transition-colors duration-300" onClick={() => setIsOpen(false)}>Get in Touch</RouterLink>
        </>
      )}
    </>
  );

  return (
    <header className="bg-white text-black pt-8 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex-shrink-0">
            <RouterLink to="/" className="text-2xl font-bold text-hovered">
              <img className="w-24 h-auto" src={logo} alt="Honex Logo" />
            </RouterLink>
          </div>

          <nav className="hidden md:flex space-x-8 items-center">
            {navLinks}
          </nav>

          <div className="md:hidden">
            <button onClick={toggleMenu} className="text-black focus:outline-none">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"} />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden fixed inset-0 bg-bg py-0">
          <div className="flex justify-between items-center h-16 px-4">
            <div className="flex-shrink-0 bg-white">
              <RouterLink to="/" className="text-2xl font-bold text-hovered" onClick={() => setIsOpen(false)}>
                <img className="w-24 h-auto" src={logo} alt="Honex Logo" />
              </RouterLink>
            </div>
            <button onClick={toggleMenu} className="text-black focus:outline-none">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <nav className="flex flex-col justify-center items-center text-center gap-8 h-screen text-xl">
            {mobileNavLinks}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;